export async function gzipBytes(input: string): Promise<Uint8Array | null> {
  try {
    if (typeof CompressionStream === "undefined") return null
    const cs = new CompressionStream("gzip")
    const blob = new Blob([input], { type: "application/json" })
    const stream = typeof blob.stream === "function" ? blob.stream() : new Response(input).body
    if (!stream) return null
    const gz = await new Response(stream.pipeThrough(cs)).arrayBuffer()
    return new Uint8Array(gz)
  } catch {
    return null
  }
}

export async function postJson(
  url: string,
  body: unknown,
  keepalive = false,
  extraHeaders: Record<string, string> = {},
  signal?: AbortSignal,
): Promise<Response> {
  const raw = typeof body === "string" ? body : JSON.stringify(body)
  const gz = await gzipBytes(raw)
  if (gz) {
    return await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Content-Encoding": "gzip",
        ...extraHeaders,
      },
      body: gz as unknown as BodyInit,
      ...(keepalive ? { keepalive: true } : {}),
      ...(signal ? { signal } : {}),
    })
  }
  return await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...extraHeaders,
    },
    body: raw,
    ...(keepalive ? { keepalive: true } : {}),
    ...(signal ? { signal } : {}),
  })
}
